import { type Maybe } from "@booking/types";
import { addDays, eachDayOfInterval } from "date-fns";
import { createStore } from "zustand/vanilla";

import { type ArrivalState, InitialDate } from "./types";

export interface ArrivalDateProps {
  dateParam: Maybe<string>;
  arrivalDate: Maybe<Date>;
  onRequest: boolean;
  ppPrice: Maybe<number>;
}

export type ArrivalDateStore = ReturnType<typeof createArrivalDateStore>;

export const createArrivalDateStore = (
  initProps?: Partial<ArrivalDateProps>,
) => {
  const DEFAULT_PROPS: ArrivalDateProps = {
    dateParam: null,
    arrivalDate: null,
    onRequest: false,
    ppPrice: null,
  };
  return createStore<ArrivalState>()((set, get) => ({
    ...DEFAULT_PROPS,
    ...initProps,

    arrivalActions: {
      setDateAndPrice: (arrivalDate: Date, ppPrice: number) => {
        set({ arrivalDate, ppPrice });
      },

      setOnRequest: (onRequest: boolean) => {
        set({ onRequest });
      },
    },
    arrivalUtils: {
      getInitialDate: (dates): InitialDate => {
        const dateParam = get().dateParam;
        if (!dateParam || !dates[dateParam]) {
          return { bookable: false, date: null, ppPrice: null };
        }

        return {
          bookable: dates[dateParam].book,
          date: new Date(dateParam),
          ppPrice: dates[dateParam].price,
        };
      },

      travelDates: (nights, arrivalDate = get().arrivalDate) =>
        arrivalDate && nights
          ? eachDayOfInterval({
              start: arrivalDate,
              end: addDays(arrivalDate, nights),
            })
          : [],
    },
  }));
};
